export default __webpack_public_path__ + "static/media/F0003.082807de.png";